module.exports = __webpack_public_path__ + "5e4cef8c37c7a94cb3019c81cbff74b3.fbx";